function getEnrollmentRequestOneData(loc, reqid, tid, tsid, at) {
  const enrollOfferRequest = {
    globalRequest: {
      clientIdentifier: 'AmexMaps',
      locale: loc,
      requestTimestamp: new Date().toISOString(),
      requestIdentifier: reqid,
    },
    enrollmentRequestParameters: {
      treatmentIdentifier: tid,
      treatmentSourceIdentifier: tsid,
      userIdentification: {
        cardObjects: [
          {
            accountToken: at,
          },
        ],
      },
      fulfillmentType: 'COUPONLESS',
    },
  };

  return enrollOfferRequest;
}

export default getEnrollmentRequestOneData;
